import { commonTranslations, coreTranslations, globalSearchTranslations, sharedTranslations } from 'translations';

const searchTermsMap = [
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_profile,
        newTerm: coreTranslations.ng_core_myInformation
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_sendMessage,
        newTerm: commonTranslations.ng_common_alerts
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_notifications,
        newTerm: commonTranslations.ng_common_alerts
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_addNewNotification,
        newTerm: commonTranslations.ng_common_alerts
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_executeScenario,
        newTerm: commonTranslations.ng_common_alerts
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_scenarioLibrary,
        newTerm: commonTranslations.ng_common_alerts
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_savedScenarios,
        newTerm: commonTranslations.ng_common_alerts
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_fileBasedMessage,
        newTerm: commonTranslations.ng_common_alerts
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_fileBasedMessaging,
        newTerm: commonTranslations.ng_common_alerts
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_recipient,
        newTerm: commonTranslations.ng_common_contacts
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_manageContacts,
        newTerm: commonTranslations.ng_common_contacts
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_addContact,
        newTerm: commonTranslations.ng_common_contacts
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_users,
        newTerm: commonTranslations.ng_common_contacts
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_addNewUser,
        newTerm: commonTranslations.ng_common_contacts
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_data,
        newTerm: coreTranslations.ng_core_dataTools
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_import,
        newTerm: coreTranslations.ng_core_dataImport
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_importWizard,
        newTerm: coreTranslations.ng_core_dataImport
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_importUsers,
        newTerm: coreTranslations.ng_core_dataImport
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_contactsLoader,
        newTerm: coreTranslations.ng_core_dataImport
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_notificationReports,
        newTerm: coreTranslations.ng_core_alertHistory
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_messageHistory,
        newTerm: coreTranslations.ng_core_alertHistory
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_callBridge,
        newTerm: coreTranslations.ng_core_conferenceBridge
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_callBridging,
        newTerm: coreTranslations.ng_core_conferenceBridge
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_weatherblast,
        newTerm: sharedTranslations.ng_shared_weatherAndEvents
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_location,
        newTerm: commonTranslations.ng_common_groups
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_direct,
        newTerm: coreTranslations.ng_core_mobile
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_folders,
        newTerm: coreTranslations.ng_core_dataImport
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_smsOptIn,
        newTerm: coreTranslations.ng_core_txtToKeyword
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_permissions,
        newTerm: coreTranslations.ng_core_accStructure
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_initiator,
        newTerm: coreTranslations.ng_core_permissionsUsers
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_sender,
        newTerm: coreTranslations.ng_core_permissionsUsers
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_messenger,
        newTerm: coreTranslations.ng_core_permissionsUsers
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_device,
        newTerm: coreTranslations.ng_core_labels
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_deviceTypes,
        newTerm: coreTranslations.ng_core_labels
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_customFields,
        newTerm: coreTranslations.ng_core_labels
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_customLabels,
        newTerm: coreTranslations.ng_core_labels
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_deviceLabels,
        newTerm: coreTranslations.ng_core_labels
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_alertTemplates,
        newTerm: coreTranslations.ng_core_customVerb
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_messageTemplates,
        newTerm: coreTranslations.ng_core_customVerb
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_customReports,
        newTerm: coreTranslations.ng_core_reports
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_recipientMessageBoards,
        newTerm: coreTranslations.ng_core_sharedMessageBoards
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_bulletin,
        newTerm: coreTranslations.ng_core_sharedMessageBoards
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_bulletinBoards,
        newTerm: coreTranslations.ng_core_sharedMessageBoards
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_gdpr,
        newTerm: coreTranslations.ng_core_dataSubRights
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_rightToBeForgotten,
        newTerm: coreTranslations.ng_core_dataSubRights
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_rtbfSubmission,
        newTerm: coreTranslations.ng_core_dataSubRights
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_myAccountInbox,
        newTerm: coreTranslations.ng_core_onsolveAnnouncements
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_auditLogs,
        newTerm: coreTranslations.ng_core_auditTrail
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_desktopAgent,
        newTerm: coreTranslations.ng_core_desktopAlerts
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_desktopAgentV2,
        newTerm: coreTranslations.ng_core_desktopAlerts
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_exportUsageDetails,
        newTerm: coreTranslations.ng_core_usage
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_notificationGroups,
        newTerm: commonTranslations.ng_common_groups
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_addNewNotificationGroup,
        newTerm: commonTranslations.ng_common_groups
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_divisions,
        newTerm: coreTranslations.ng_core_dataHierarchy
    },
    {
        legacyTerm: globalSearchTranslations.ng_globalSearch_accountability,
        newTerm: coreTranslations.ng_core_contactAccounting
    }
];

export default searchTermsMap;
